import avt from "../logomp.jpg"

const Header = () => {
    return (
        <div id="top-header">
            <div class="container">
                <ul class="header-links pull-left">
                    <li><a href="#"><i class="fa fa-phone"></i> 0918.711.711 (Anh Thảo)</a></li>
                    <li><a href="#"><i class="fa fa-phone"></i> 0974.379.047 (Anh Tâm)</a></li>
                    <li><a href="#"><i class="fa fa-envelope-o"></i> minhphatsgb@gmail.com</a></li>
                    <li><a href="#"><i class="fa fa-map-marker"></i> 2/1A Liên Khu 2-10, Phường Bình Hưng Hòa A, Quận Bình Tân</a></li>
                    <li><a href="#"><i class="fa fa-code"></i>MST: 0316091469</a></li>
                </ul>
            </div>
        </div>
    )
}
export default Header;